import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Calendar, MapPin, DollarSign, Users } from "lucide-react";

export default function Camps() {
  const [camps, setCamps] = useState([]);
  const [active, setActive] = useState(null);
  const [form, setForm] = useState({ player_name: "", parent_name: "", email: "", phone: "", notes: "" });
  useEffect(() => { api.get("/camps").then((r) => setCamps(r.data)); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/camp-registrations", { ...form, camp_id: active.id });
      toast.success("Registration submitted!");
      setActive(null);
      setForm({ player_name: "", parent_name: "", email: "", phone: "", notes: "" });
    } catch (err) {
      toast.error("Failed to submit. Try again.");
    }
  };
  return (
    <div data-testid="camps-page" className="py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="eyebrow mb-3">Camps & Clinics</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase font-bold tracking-tight">Train with the Kraken</h1>
        <p className="text-slate-400 mt-4 max-w-2xl">Open to players outside our roster. Quality instruction from coaches who've been there.</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {camps.map((c) => (
            <div key={c.id} className="kr-card rounded-xl p-6 flex flex-col" data-testid={`camp-${c.id}`}>
              <div className="eyebrow mb-2">{c.type}</div>
              <div className="font-display text-2xl uppercase">{c.title}</div>
              <div className="text-slate-400 text-sm mt-3 space-y-1">
                <div><Calendar size={14} className="inline mr-2" />{c.date}</div>
                <div><MapPin size={14} className="inline mr-2" />{c.location}</div>
                <div><Users size={14} className="inline mr-2" />Capacity: {c.capacity}</div>
                <div><DollarSign size={14} className="inline mr-2" />${c.price}</div>
              </div>
              <p className="text-slate-300 text-sm mt-4 leading-relaxed flex-1">{c.description}</p>
              <button onClick={() => setActive(c)} className="btn-primary mt-5 justify-center" data-testid={`register-${c.id}`}>Register</button>
            </div>
          ))}
        </div>

        {active && (
          <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setActive(null)}>
            <form onClick={(e) => e.stopPropagation()} onSubmit={submit} className="kr-card rounded-2xl p-8 max-w-md w-full space-y-4" data-testid="camp-register-form">
              <div>
                <div className="eyebrow mb-1">Register</div>
                <div className="font-display text-2xl uppercase">{active.title}</div>
              </div>
              <input required placeholder="Player Name" value={form.player_name} onChange={(e) => setForm({ ...form, player_name: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
              <input required placeholder="Parent Name" value={form.parent_name} onChange={(e) => setForm({ ...form, parent_name: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
              <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
              <input required placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
              <textarea placeholder="Notes (optional)" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} rows={3} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
              <div className="flex gap-2">
                <button type="button" onClick={() => setActive(null)} className="btn-ghost flex-1 justify-center">Cancel</button>
                <button type="submit" className="btn-primary flex-1 justify-center" data-testid="submit-camp-reg">Submit</button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
